import React, { Component } from 'react';
import Halogen from 'halogen'

class Load extends Component {

  render() {
    return (
      <div style={{display: 'flex', justifyContent: 'center'}}>
        <Halogen.PulseLoader color={'#888888'}/>
      </div>
    );
  }
}

export default Load;



// WEBPACK FOOTER //
// ./src/components/Load.jsx